// extracted by mini-css-extract-plugin
module.exports = {"row":"_base-row-d63f9d494f0f924715213b2763521b25"};